// extracted by mini-css-extract-plugin
export default {"hiddenClearButton":"FavoritesSearchInput_hiddenClearButton__1opRu"};